var path = '/Laboratory/'

function get (http, id) {
    return http.get(`${path}Get?laboratoryId=${id}`)
}

function put (http, dto) {
    return http.put(path, dto)
}

function remove (http, id) {
    return http.post(`${path}Remove?laboratoryId=${id}`)
}

function list (http) {
    return http.post(`${path}List`)
}

export default {
    get: get,
    put: put,
    remove: remove,
    list: list
}



// WEBPACK FOOTER //
// ./src/services/laboratoryService.js